import _omit from "lodash/omit";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { HazardousMaterial } from 'swag-common/interfaces';
const SIZE_STANDARD_INDEX = 0;
const VARIANT_STANDARD_INDEX = 0;
const PRODUCTION_TIME_STANDARD_INDEX = 0;
const FULL_DESIGN_DEFAULT_VARIANT_INDEX = 0;
export const BACK_IN_STOCK_VALID_DATE_FORMAT = 'MM/DD/YYYY';
const FRONT = 'front';
const BACK = 'back';
const LEFT = 'left';
const RIGHT = 'right';
const BRANDED = 'branded';
const PRINT_SIDE = {
  [FRONT]: FRONT,
  [BACK]: BACK,
  [LEFT]: LEFT,
  [RIGHT]: RIGHT
};
const BASIC_BOX = 'basicBox';
const DEFAULT_TAX_CODE = 'PP198874';
const MAX_QUANTITY_TO_BUY = 100000;
const PRODUCTION_TIME_STANDART_TEXT = 'Standard';
const PRODUCTION_TIME_PRIORITY_TEXT = 'Priority';
const PRODUCTION_TIME_VIP_TEXT = 'VIP';
export const PRODUCTION_TIME_SAMPLE_VALUE = 0;
export const PRODUCTION_TIME_SAMPLE_DAYS = 1;
export const PRODUCTION_TIME_SAMPLE_TEXT = 'Sample';
export const SAMPLE_PRODUCTION_TIME_OBJECT = {
  name: PRODUCTION_TIME_SAMPLE_TEXT,
  cost: PRODUCTION_TIME_SAMPLE_VALUE,
  time: PRODUCTION_TIME_SAMPLE_DAYS
};
export const MAX_PRINT_COLORS_LIMIT = 20;
const MAX_CUSTOM_BOX_PRODUCTS = 7;
const PRODUCT_VISIBILITY = {
  HIDDEN: 'hidden',
  REGULAR: 'regular',
  SEARCHABLE_ONLY: 'searchableOnly',
  LINK_ONLY: 'linkOnly',
  LIMITED_EDITION: 'limitedEdition.isLimitedEdition',
  FORBIDDEN_FOR_BOX: 'forbiddenForBox',
  IS_SUGGESTED: 'isSuggested',
  SPECIAL_PRODUCTS: 'specialProductType',
  IS_BASIC_BOX: 'isBasicBox',
  // @todo
  HAS_DONATE_WIDGET: 'hasDonateWidget',
  IS_ALWAYS_IN_STOCK: 'isAlwaysInStock',
  FORBIDDEN_FOR_INVENTORY: 'forbiddenForInventory',
  FOOD_PRODUCTS: 'foodProducts',
  IS_BREAKABLE_PRODUCTS: 'isBreakable',
  SUPER_SPEED: 'superSpeed',
  CORE: 'core',
  IS_CUSTOM_INK_OFS_FLOW_ENABLED: 'isCustomInkOFSFlowEnabled'
};
export const NOT_CORE_PRODUCTS = [PRODUCT_VISIBILITY.HIDDEN, PRODUCT_VISIBILITY.LINK_ONLY, PRODUCT_VISIBILITY.SEARCHABLE_ONLY];
const PRODUCT_SORTING = {
  HIGHEST_PRICE: 'highestPrice',
  LOWEST_PRICE: 'lowestPrice',
  LATEST: 'latest',
  NEWEST: 'newest',
  MOST_POPULAR: 'mostPopular',
  CUSTOM: 'custom',
  RELEVANCE: 'relevance',
  HOTTEST: 'hottest'
};
export const CSV_COLUMNS = {
  NAME: 'Product name',
  NUM: 'Num',
  TAX_CODE: 'Tax code',
  MIN_QUANT: 'Minimum Quantity',
  QUANT_INCREMENT: 'Quantity increment',
  PRODUCTION_TIME_LIST: 'Production time (Format: NAME-COST INCREASE (%)-TIME (DAYS)/NAME-COST INCREASE (%)-TIME (DAYS))',
  SUPER_SPEED: 'EmbellishmentMethod; MinQuant; MaxQuant; MaxPrintColors (only for Super Speed)',
  POPULARITY: 'Popularity',
  DESCRIPTION_FOR_WAREHOUSE: 'Description for Warehouse',
  DESCRIPTION: 'Description',
  SEO_TITLE: 'SEO title',
  SEO_DESCRIPTION: 'SEO description',
  PRINTING_PROCESS_DESCRIPTION: 'Printing process description',
  BOX_LENGTH: 'Box length',
  BOX_WIDTH: 'Box width',
  BOX_HEIGHT: 'Box height',
  BOX_WEIGHT: 'Box weight',
  ITEM_WEIGHT: 'One item weight',
  ITEMS_IN_BOX: 'Items in a box',
  EMBELLISHMENT_METHODS: 'Embellishment',
  MARGIN: 'Margin',
  SCREEN_PRICE: 'Screen price',
  MAX_PRINT_COLORS: 'Max print colors',
  DISTRIBUTION_FEE: 'Distribution fee',
  SAMPLE_PRICE: 'Blank sample price',
  PRINTED_SAMPLE_PRICE: 'Printed sample price',
  PRODUCT_LABEL: 'Product label',
  SIZE_DEPENDENT_PRICE: 'Size-dependent price',
  EMBROIDERY_PRODUCT: 'Embroidery product',
  VARIANT_DEPENDENT_PRICE: 'Variant-dependent price',
  ADD_ONE_COLOR: 'Add one color',
  SWAG_LOGO_DISCOUNT: '10% discount option (printed swag.com logo)',
  _ID: 'Product ID (not editable)',
  CATEGORIES: 'Categories IDs (not editable)',
  SUPPLIER: 'Vendor ID (not editable)',
  HIDDEN: 'Hidden',
  OUT_OF_STOCK: 'Out of stock',
  BACK_IN_STOCK: `Back in stock (${BACK_IN_STOCK_VALID_DATE_FORMAT})`,
  IS_SUGGESTED: 'Is suggested',
  FORBIDDEN_FOR_BOX: 'Forbidden for box',
  FORBIDDEN_FOR_INVENTORY: 'Forbidden for inventory',
  HAZARDOUS_MATERIAL: `Hazardous materials (${Object.values(HazardousMaterial).join('/')})`,
  LINK_ONLY: 'Link only',
  SEARCHABLE_ONLY: 'Searchable only',
  CREATED_AT: 'Created At (not editable)',
  IS_BREAKABLE: 'Breakable'
};
const CSV_ATTRIBUTES_COLUMNS = {
  NAME: 'Product name (not editable)',
  _ID: 'Product ID (not editable)'
};
const FIELD_TYPES = {
  ARRAY: ['embellishmentMethods', 'tenantVisibility', 'priceTags'],
  STRING: ['name', 'num', 'taxCode', 'descr', 'seoTitle', 'seoDescription', 'printingProcessDescription', 'productLabel', 'hazardousMaterial'],
  NUMBER: ['boxLength', 'boxWidth', 'boxHeight', 'boxWeight', 'itemWeight', 'itemsInBox', 'margin', 'minQuant', 'quantIncrement', 'maxPrintColors', 'spaceMargin'],
  PRICE: ['screenPrice', 'distributionFee', 'samplePrice', 'printedSamplePrice'],
  BOOLEAN: ['sizeDependentPrice', 'variantDependentPrice', 'addOneColor', 'swagLogoDiscount', 'colorIndependentPrice', 'colorIndependentScreenPrice', 'hidden', 'linkOnly', 'searchableOnly', 'isSuggested', 'forbiddenForBox', 'forbiddenForInventory', 'isBreakable', 'isCustomInkOFSFlowEnabled'],
  SKIP: ['categories', 'supplier', 'createdAt'],
  SORTING: ['popularity']
};
const PRODUCTS_ORDERED_FIELDS = ['name', 'num', 'taxCode', 'minQuant', 'quantIncrement', 'productionTimeList', 'superSpeed', 'popularity', 'descriptionForWarehouse', 'description', 'seoTitle', 'seoDescription', 'printingProcessDescription', 'boxLength', 'boxWidth', 'boxHeight', 'boxWeight', 'itemWeight', 'itemsInBox', 'isCustomInkOFSFlowEnabled', 'embellishmentMethods', 'margin', 'spaceMargin', 'resellerMarginReduction', 'tenantVisibility', 'screenPrice', 'priceTags', 'maxPrintColors', 'distributionFee', 'samplePrice', 'printedSamplePrice', 'productLabel', 'hidden', 'linkOnly', 'searchableOnly', 'isSuggested', 'isBreakable', 'forbiddenForBox', 'forbiddenForInventory', 'hazardousMaterial', 'sizeDependentPrice', 'colorIndependentPrice', 'colorIndependentScreenPrice', 'variantDependentPrice', 'addOneColor', 'swagLogoDiscount', 'createdAt', 'categories', 'supplier', '_id'];
const APPAREL_SIZE_NAMES = {
  XS: 'Extra Small',
  S: 'Small',
  M: 'Medium',
  L: 'Large',
  XL: 'Extra Large'
};
export const DESCRIPTION_FOR_WAREHOUSE_CHARACTERS_LIMIT = 20;
const CSV_COLUMNS_PRODUCT = {
  name: 'Product name',
  num: 'Num',
  taxCode: 'Tax code',
  minQuant: 'Minimum Quantity',
  quantIncrement: 'Quantity increment',
  productionTimeList: 'Production time (Format: NAME-COST INCREASE (%)-TIME (DAYS)/NAME-COST INCREASE (%)-TIME (DAYS))',
  superSpeed: 'EmbellishmentMethod; MinQuant; MaxQuant; MaxPrintColors (only for Super Speed)',
  popularity: 'Popularity',
  descriptionForWarehouse: 'Description for Warehouse',
  description: 'Description',
  seoTitle: 'SEO title',
  seoDescription: 'SEO description',
  printingProcessDescription: 'Printing process description',
  // start add shipping setting
  boxLength: 'Box length',
  boxWidth: 'Box width',
  boxHeight: 'Box height',
  boxWeight: 'Box weight',
  itemWeight: 'One item weight',
  itemsInBox: 'Items in a box',
  isCustomInkOFSFlowEnabled: 'Custom Ink OFS flow',
  // end add shipping setting
  embellishmentMethods: 'Embellishment',
  margin: 'Margin',
  spaceMargin: 'Swag Space margin',
  resellerMarginReduction: 'Reseller commission (value from 0 to 29 or empty cell)',
  tenantVisibility: 'Tenant visibility',
  screenPrice: 'Screen price',
  priceTags: 'Reseller price tags',
  maxPrintColors: 'Max print colors',
  distributionFee: 'Distribution fee',
  samplePrice: 'Blank sample price',
  printedSamplePrice: 'Printed sample price',
  productLabel: 'Product label',
  isSuggested: 'Is suggested',
  linkOnly: 'Link only',
  searchableOnly: 'Searchable only',
  forbiddenForBox: 'Forbidden for box',
  forbiddenForInventory: 'Forbidden for inventory',
  hazardousMaterial: `${CSV_COLUMNS.HAZARDOUS_MATERIAL}`,
  hidden: 'Hidden',
  // start pricing options
  sizeDependentPrice: 'Size-dependent price',
  embroideryProduct: 'Embroidery product',
  variantDependentPrice: 'Variant-dependent price',
  addOneColor: 'Add one color',
  swagLogoDiscount: '10% discount option (printed swag.com logo)',
  // end pricing options
  createdAt: 'Created At (not editable)',
  _id: 'Product ID (not editable)',
  categories: 'Categories IDs (not editable)',
  supplier: 'Vendor ID (not editable)',
  isBreakable: 'Breakable',
  colorIndependentScreenPrice: 'Digital print product'
};
const PRODUCTS_HEAD = _objectSpread({}, _omit(CSV_COLUMNS_PRODUCT, 'embroideryProduct'), {
  colorIndependentPrice: 'Embroidery product'
});
const MAP_HEADER_TO_FIELDS = Object.fromEntries(Object.entries(_objectSpread({}, PRODUCTS_HEAD, {
  descr: 'Description'
})).map(item => item.reverse()));
export const SUPER_SPEED_PRODUCTION_OPTION = 'Super Speed';
const PRODUCTION_TIME_NAMES_MAP = {
  expedited: 'Expedited',
  priority: 'Priority',
  standard: 'Standard',
  overseas: 'Overseas',
  rush: 'Rush',
  vip: 'VIP',
  sample: 'Sample',
  'next day': 'Next day',
  'super speed': SUPER_SPEED_PRODUCTION_OPTION
};
const PRODUCTION_TIME_NAMES = Object.values(PRODUCTION_TIME_NAMES_MAP);
const PRODUCT_ATTRIBUTES_HEAD = {
  _id: 'Product ID (not editable)',
  name: 'Product name (not editable)'
};
const PRODUCT_ATTRIBUTES_ORDERED_FIELDS = ['_id', 'name'];
const PRODUCT_LABELS = {
  NEW: 'new',
  HOT: 'hot',
  NONE: null
};
export let LOGO_UPLOAD_BLANK_OPTIONS = /*#__PURE__*/function (LOGO_UPLOAD_BLANK_OPTIONS) {
  LOGO_UPLOAD_BLANK_OPTIONS["ONLY_PRINTED"] = "ONLY_PRINTED";
  LOGO_UPLOAD_BLANK_OPTIONS["ONLY_BLANK"] = "ONLY_BLANK";
  LOGO_UPLOAD_BLANK_OPTIONS["BLANK_AND_PRINTED"] = "BLANK_AND_PRINTED";
  return LOGO_UPLOAD_BLANK_OPTIONS;
}({});
export let SPECIAL_PRODUCT_TYPES = /*#__PURE__*/function (SPECIAL_PRODUCT_TYPES) {
  SPECIAL_PRODUCT_TYPES["BOX_NOTECARD"] = "BOX_NOTECARD";
  SPECIAL_PRODUCT_TYPES["BOX_TAPE"] = "BOX_TAPE";
  SPECIAL_PRODUCT_TYPES["BOX_CRINKLE_PAPER"] = "BOX_CRINKLE_PAPER";
  SPECIAL_PRODUCT_TYPES["SAMPLE_BOX"] = "SAMPLE_BOX";
  SPECIAL_PRODUCT_TYPES["CUSTOM_BOX"] = "CUSTOM_BOX";
  SPECIAL_PRODUCT_TYPES["BROWN_BOX"] = "BROWN_BOX";
  SPECIAL_PRODUCT_TYPES["COLORED_BOX"] = "COLORED_BOX";
  SPECIAL_PRODUCT_TYPES["FULLY_CUSTOM_BOX"] = "FULLY_CUSTOM_BOX";
  SPECIAL_PRODUCT_TYPES["ADD_ON_FOR_BOX"] = "ADD_ON_FOR_BOX";
  SPECIAL_PRODUCT_TYPES["GIFT_GIVEAWAY_NOTECARD"] = "GIFT_GIVEAWAY_NOTECARD";
  return SPECIAL_PRODUCT_TYPES;
}({});
export const SPECIAL_PRODUCT_TYPES_ARR = [SPECIAL_PRODUCT_TYPES.BOX_NOTECARD, SPECIAL_PRODUCT_TYPES.BOX_TAPE, SPECIAL_PRODUCT_TYPES.BOX_CRINKLE_PAPER, SPECIAL_PRODUCT_TYPES.SAMPLE_BOX, SPECIAL_PRODUCT_TYPES.CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.BROWN_BOX, SPECIAL_PRODUCT_TYPES.COLORED_BOX, SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.ADD_ON_FOR_BOX, SPECIAL_PRODUCT_TYPES.GIFT_GIVEAWAY_NOTECARD];
export const BOX_TYPE_FOR_SELECTION = [SPECIAL_PRODUCT_TYPES.BROWN_BOX, SPECIAL_PRODUCT_TYPES.COLORED_BOX, SPECIAL_PRODUCT_TYPES.CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX];
export const CUSTOM_BOXES = [SPECIAL_PRODUCT_TYPES.CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX];
export let PRODUCT_PRICE_TAGS = /*#__PURE__*/function (PRODUCT_PRICE_TAGS) {
  PRODUCT_PRICE_TAGS["SUPER_INEXPENSIVE"] = "SUPER_INEXPENSIVE";
  PRODUCT_PRICE_TAGS["BUDGET"] = "BUDGET";
  PRODUCT_PRICE_TAGS["STANDARD"] = "STANDARD";
  PRODUCT_PRICE_TAGS["PREMIUM"] = "PREMIUM";
  return PRODUCT_PRICE_TAGS;
}({});
export const PRODUCT_PRICE_TAGS_MAP = {
  isSuperInexpensive: PRODUCT_PRICE_TAGS.SUPER_INEXPENSIVE,
  isBudget: PRODUCT_PRICE_TAGS.BUDGET,
  isStandard: PRODUCT_PRICE_TAGS.STANDARD,
  isPremium: PRODUCT_PRICE_TAGS.PREMIUM
};
export const PRODUCT_PRICE_TAGS_OPTIONS = [{
  label: 'Super inexpensive',
  value: PRODUCT_PRICE_TAGS.SUPER_INEXPENSIVE
}, {
  label: 'Budget',
  value: PRODUCT_PRICE_TAGS.BUDGET
}, {
  label: 'Standard',
  value: PRODUCT_PRICE_TAGS.STANDARD
}, {
  label: 'Premium',
  value: PRODUCT_PRICE_TAGS.PREMIUM
}];
export const PRODUCT_PRICE_TAGS_OPTIONS_MAP = PRODUCT_PRICE_TAGS_OPTIONS.reduce((acc, {
  label,
  value
}) => {
  acc[value] = label;
  return acc;
}, {});
export const ADDITIONAL_PRODUCT_TIME_TEXT = 'After artwork approval';
const LOGO_UPLOAD_BLANK_OPTIONS_VALUES = [{
  label: 'Only printed',
  value: LOGO_UPLOAD_BLANK_OPTIONS.ONLY_PRINTED
}, {
  label: 'Blank and printed',
  value: LOGO_UPLOAD_BLANK_OPTIONS.BLANK_AND_PRINTED
}, {
  label: 'Only blank',
  value: LOGO_UPLOAD_BLANK_OPTIONS.ONLY_BLANK
}];
const LOGO_UPLOAD_BLANK_OPTIONS_LABELS_BY_VALUE = LOGO_UPLOAD_BLANK_OPTIONS_VALUES.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});
export { SIZE_STANDARD_INDEX, VARIANT_STANDARD_INDEX, PRODUCTION_TIME_STANDARD_INDEX, FULL_DESIGN_DEFAULT_VARIANT_INDEX, PRINT_SIDE, MAX_QUANTITY_TO_BUY, PRODUCTION_TIME_STANDART_TEXT, PRODUCTION_TIME_PRIORITY_TEXT, PRODUCTION_TIME_VIP_TEXT, MAX_CUSTOM_BOX_PRODUCTS, CSV_COLUMNS_PRODUCT, PRODUCTS_ORDERED_FIELDS, PRODUCTS_HEAD, MAP_HEADER_TO_FIELDS, FIELD_TYPES, FRONT, BACK, LEFT, RIGHT, BRANDED, PRODUCTION_TIME_NAMES, PRODUCTION_TIME_NAMES_MAP, PRODUCT_ATTRIBUTES_HEAD, PRODUCT_ATTRIBUTES_ORDERED_FIELDS, CSV_ATTRIBUTES_COLUMNS, PRODUCT_VISIBILITY, PRODUCT_SORTING, BASIC_BOX, APPAREL_SIZE_NAMES, DEFAULT_TAX_CODE, PRODUCT_LABELS, LOGO_UPLOAD_BLANK_OPTIONS_VALUES, LOGO_UPLOAD_BLANK_OPTIONS_LABELS_BY_VALUE };
export let responseText = /*#__PURE__*/function (responseText) {
  responseText["SUCCESS"] = "Thanks! We will send you an email when they are back in stock.";
  responseText["LIMITED_EDITION_SUCCESS"] = "Thanks! We will send you an email when we release new limited edition products.";
  responseText["REMOVED"] = "Email subscription was successfully removed.";
  responseText["ERROR"] = "Oops, something went wrong!";
  return responseText;
}({});
export const BOX_TYPES_LABELS = {
  [SPECIAL_PRODUCT_TYPES.COLORED_BOX]: 'Colored box (unbranded)',
  [SPECIAL_PRODUCT_TYPES.CUSTOM_BOX]: 'Custom  box',
  [SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX]: 'Fully Custom box',
  [SPECIAL_PRODUCT_TYPES.BROWN_BOX]: 'Brown box with logo tape'
};
export const InReservePopupTypes = {
  IN_STOCK: 'inStock',
  IN_PRODUCTION: 'inProduction',
  ALL: 'all',
  IN_STOCK_AVAILABLE: 'inStockAvailable',
  IN_PRODUCTION_AVAILABLE: 'inProductionAvailable'
};
export const PRODUCT_PROPERTIES = {
  apparelSize: 'Apparel Size',
  quantity: 'Quantity',
  color: 'Color',
  size: 'Size'
};
export const LIMITED_EDITION = 'Limited Edition!';
export const STRINGIFIED_FIELDS = ['categories', 'variants', 'price', 'quantities', 'printRunPrices', 'printRunQuantities', 'imagesForSpec', 'productionTimeList', 'tags', 'imagesWithoutImprintArea', 'embellishmentMethods', 'sortingParams', 'tenantVisibility', 'supplierInventoryLevels', 'attributeValueIds', 'tagsSrc', 'blankProductionTimeList', 'additionalPrintLocations', 'products', 'limitedEdition', 'superSpeed', 'priceTags'];
export const MAX_PRODUCT_INPUT_NAME_LENGTH = 100;
export const MIN_PRODUCT_INPUT_NAME_LENGTH = 1;
export const MAX_PRODUCT_TEXTAREA_INPUT_LENGTH = 1000;
export const MIN_PRODUCT_TEXTAREA_INPUT_LENGTH = 1;
export const PROD_TIME = {
  LESS_THAN_5_DAYS: '0,5'
};
export const PRODUCT_ATTRIBUTES_NAMES = {
  FOOD: 'food'
};
export const EMBELLISHMENT_METHODS = {
  DEBOSSED: 'debossed',
  LASER_ENGRAVE: 'laser engrave',
  EMBROIDERY: 'embroidery'
};
export const MAX_IMAGES_NAME_LENGTH = 25;
export const MAX_PRODUCT_PRINT_COLORS = 25;
export const NA = 'N/A';
export let PRODUCT_STATUS = /*#__PURE__*/function (PRODUCT_STATUS) {
  PRODUCT_STATUS["IMPORTED"] = "imported";
  PRODUCT_STATUS["CREATED"] = "created";
  PRODUCT_STATUS["IN_PROGRESS"] = "in progress";
  PRODUCT_STATUS["ON_REVIEW"] = "on review";
  PRODUCT_STATUS["CHANGES_REQUESTED"] = "changes requested";
  PRODUCT_STATUS["COMPLETED"] = "completed";
  return PRODUCT_STATUS;
}({});
export let PRODUCT_STATUS_OPTIONS_TYPE = /*#__PURE__*/function (PRODUCT_STATUS_OPTIONS_TYPE) {
  PRODUCT_STATUS_OPTIONS_TYPE["ALL"] = "all";
  PRODUCT_STATUS_OPTIONS_TYPE["EDITOR"] = "editor";
  return PRODUCT_STATUS_OPTIONS_TYPE;
}({});
export const PRODUCT_STATUS_LABELS = {
  [PRODUCT_STATUS.IMPORTED]: 'Imported',
  [PRODUCT_STATUS.CREATED]: 'Created',
  [PRODUCT_STATUS.IN_PROGRESS]: 'In progress',
  [PRODUCT_STATUS.ON_REVIEW]: 'On review',
  [PRODUCT_STATUS.CHANGES_REQUESTED]: 'Changes requested',
  [PRODUCT_STATUS.COMPLETED]: 'Completed'
};